const hyphens = () => {
	if (document.body.clientWidth > 1024) {
		console.log('resizing');
		let items = document.querySelectorAll('.js-hyphens-item');
		if (items) {
			items.forEach(function (item) {
				let fontSize;
				let box1 = item.querySelector('.js-hyphens-box-1');
				let box2 = item.querySelector('.js-hyphens-box-2');
				let title = item.querySelector('.js-hyphens-element');
				while (box1.clientHeight > box2.clientHeight) {
					fontSize = window.getComputedStyle(title, null).getPropertyValue('font-size');
					title.style.fontSize = parseInt(parseInt(fontSize) - 0.25) + 'px';
				}
			})
		}
	} else {
		console.log('not resizing');
	}
}

export default hyphens;